import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["title"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("h3", {
        class: _normalizeClass(["badge badge-output-bg", $props.classes]),
        style: _normalizeStyle($setup.backgroundColor),
        title: $props.certification.label
    }, [
        _createElementVNode("span", {
            class: "badge-output-font",
            style: _normalizeStyle($setup.fontColor)
        }, _toDisplayString($props.certification.slug), 5)
    ], 14, _hoisted_1));
}
